module.exports = __webpack_public_path__ + "static/media/camion.9f16d8ed.svg";